import { Box } from '@chakra-ui/react';
import React from 'react';
import { Home } from './Home';
import { About } from './About';
import { Service } from './Service';
import { Projects } from './Projects';
import Footer from './Footer';

export const MainScreen = () => {
  return (
    <Box>
      <Home />
      <About />
      <Service />
      <Projects />
      <Footer />
    </Box>
  );
};
